export const API_URL = "https://pizza-delivary-app.herokuapp.com";
// export const API_URL = "http://localhost:8000";
